import { Badge, Button, Form, Image, Modal } from "react-bootstrap";
import { FaTimesCircle } from "react-icons/fa";
import { useState, useEffect } from "react";

const EditPartnerModal = ({
  show,
  onHide,
  isEdit = false,
  form,
  setForm,
  onExited,
  clearFieldError,
  fieldErrors,
  savePartner,
  onClose,
  buildLogoUrl,
}) => {
  const [phoneInput, setPhoneInput] = useState("");
  const [phoneList, setPhoneList] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [emailInput, setEmailInput] = useState("");

  console.log(
    "EditPartnerModal render - form.mobile_number:",
    form.mobile_number
  );

  // 🔹 Parse backend "number/number" into an array on mount or form change
  useEffect(() => {
    console.log("Parsing mobile_number:", form.mobile_number);

    if (form.mobile_number) {
      const numbers = form.mobile_number
        .split("/")
        .map((n) => n.trim())
        .filter((n) => n);
      setPhoneList(numbers);
    } else {
      setPhoneList([]);
    }

    if (form.email) {
      const emails = form.email
        .split("/")
        .map((n) => n.trim())
        .filter((n) => n);
      setEmailList(emails);
    } else {
      setEmailList([]);
    }
  }, [form.mobile_number, form.email]);
  // remove logo helper
  const removeLogo = () => {
    setForm({ ...form, logo: undefined, logoPreview: undefined });
  };

  // Handle phone number addition
  const handleAddPhone = () => {
    const num = phoneInput.trim();
    if (!num) return;

    // Basic validation (optional)
    const isValid = /^[0-9]{10}$/.test(num);
    if (!isValid) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    if (phoneList.includes(num)) {
      setPhoneInput("");
      return;
    }

    const updatedList = [...phoneList, num];
    setPhoneList(updatedList);

    const joined = updatedList.join(" / ");
    setForm({ ...form, mobile_number: joined });
    setPhoneInput("");
    clearFieldError("mobile_number");

    // const updatedList = [...(form.mobile_number || []), num];
    // setForm({ ...form, mobile_number: updatedList });
    // setPhoneInput("");
    // clearFieldError("mobile_number");
  };

  // Handle email  addition
  const handleAddEmail = () => {
    const mail = emailInput.trim();
    if (!mail) return;

    if (emailList.includes(mail)) {
      setEmailInput("");
      return;
    }

    const updatedList = [...emailList, mail];
    setEmailList(updatedList);

    const joined = updatedList.join(" / ");
    setForm({ ...form, email: joined });
    setEmailInput("");
    clearFieldError("email");
  };

  // Handle Enter or comma key
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      handleAddPhone();
    }
  };

  // Remove a specific number
  // const removePhone = (num) => {
  //   const updatedList = form.mobile_numbers.filter((n) => n !== num);
  //   setForm({ ...form, mobile_numbers: updatedList });
  // };
  const removePhone = (num) => {
    const updatedList = phoneList.filter((n) => n !== num);
    setPhoneList(updatedList);
    const joined = updatedList.join(" / ");
    setForm({ ...form, mobile_number: joined });
  };

  const removeEmail = (email) => {
    const updatedList = emailList.filter((n) => n !== email);
    setEmailList(updatedList);
    const joined = updatedList.join(" / ");
    setForm({ ...form, email: joined });
  };

  return (
    <Modal show={show} onHide={onHide} onExited={onExited} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Edit Partner" : "Add Partner"}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={savePartner}>
        <Modal.Body>
          <div className="d-grid columns-3 gap-3">
            {/* Logo Upload + Preview */}
            <Form.Group
              className="d-grid columns-2 gap-3 span-3"
              style={{ height: "80px" }}
              controlId="partner-logo"
            >
              <div>
                <Form.Label>Logo</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      const url = URL.createObjectURL(file);
                      setForm({ ...form, logo: file, logoPreview: url });
                      clearFieldError("logo");
                    }
                  }}
                />
              </div>

              {/* Show Preview */}
              {(form.logoPreview || form.logo) && (
                <figure
                  className="position-relative d-flex align-items-center justify-content-center m-0 h-100"
                  style={{ width: "120px" }}
                >
                  <Image
                    src={
                      form.logoPreview
                        ? form.logoPreview
                        : buildLogoUrl(form.logo)
                    }
                    alt="Preview"
                    style={{ height: "80px", objectFit: "contain" }}
                    fluid
                    className="rounded-2"
                  />

                  {/* Cross Button inside image corner */}
                  <FaTimesCircle
                    onClick={removeLogo}
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      cursor: "pointer",
                      color: "#bf352b",
                      fontSize: "20px",
                    }}
                  />
                </figure>
              )}
            </Form.Group>

            {/* Partner Code */}
            <Form.Group controlId="partner-code">
              <Form.Label>Partner Code*</Form.Label>
              <Form.Control
                value={form.partner_code}
                onChange={(e) => {
                  const v = e.target.value.toUpperCase();
                  setForm({ ...form, partner_code: v });
                  clearFieldError("partner_code");
                }}
                disabled={!!isEdit}
                isInvalid={!!fieldErrors.partner_code}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.partner_code}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Name */}
            <Form.Group controlId="partner-name">
              <Form.Label>Name*</Form.Label>
              <Form.Control
                value={form.name}
                onChange={(e) => {
                  setForm({ ...form, name: e.target.value });
                  clearFieldError("name");
                }}
                isInvalid={!!fieldErrors.name}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.name}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Company Name */}
            <Form.Group controlId="company-name">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                value={form.company_name}
                onChange={(e) =>
                  setForm({ ...form, company_name: e.target.value })
                }
              />
            </Form.Group>

            {/* Email */}
            <Form.Group controlId="partner-email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={form.email}
                onChange={(e) => setEmailInput(e.target.value)}
                isInvalid={!!fieldErrors.email}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.email}
              </Form.Control.Feedback>
              <div className="mt-2 d-flex flex-wrap gap-2">
                {emailList.map((mail, idx) => (
                  <Badge
                    key={idx}
                    pill
                    bg="secondary"
                    className="d-flex align-items-center gap-1"
                  >
                    {mail}
                    <FaTimesCircle
                      onClick={() => removeEmail(mail)}
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        color: "white",
                      }}
                    />
                  </Badge>
                ))}
              </div>
              {phoneList.length > 0 && (
                <Form.Text muted className="mt-1 d-block">
                  Saved as: {emailList.join(" / ")}
                </Form.Text>
              )}
            </Form.Group>

            {/* Website */}
            <Form.Group controlId="partner-website">
              <Form.Label>Website</Form.Label>
              <Form.Control
                // type="url"
                // placeholder="https://example.com"
                value={form.website}
                onChange={(e) => {
                  setForm({ ...form, website: e.target.value.trim() });
                  clearFieldError("website");
                }}
                isInvalid={!!fieldErrors.website}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.website}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Mobile Number */}
            {/* <Form.Group controlId="partner-mobile">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                value={form.mobile_number}
                onChange={(e) => {
                  setForm({ ...form, mobile_number: e.target.value });
                  clearFieldError("mobile_number");
                }}
                isInvalid={!!fieldErrors.mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.mobile_number}
              </Form.Control.Feedback>
            </Form.Group> */}

            {/* Multiple Mobile Numbers */}
            <Form.Group controlId="partner-mobile">
              <Form.Label>Mobile Numbers</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter number and press Enter or comma"
                value={phoneInput}
                onChange={(e) => setPhoneInput(e.target.value)}
                onKeyDown={handleKeyDown}
                isInvalid={!!fieldErrors.mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.mobile_number}
              </Form.Control.Feedback>

              <div className="mt-2 d-flex flex-wrap gap-2">
                {phoneList.map((num, idx) => (
                  <Badge
                    key={idx}
                    pill
                    bg="secondary"
                    className="d-flex align-items-center gap-1"
                  >
                    {num}
                    <FaTimesCircle
                      onClick={() => removePhone(num)}
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        color: "white",
                      }}
                    />
                  </Badge>
                ))}
              </div>
              {phoneList.length > 0 && (
                <Form.Text muted className="mt-1 d-block">
                  Saved as: {phoneList.join(" / ")}
                </Form.Text>
              )}
            </Form.Group>

            {/* ARN/AFMI */}
            <Form.Group controlId="arn/afmi">
              <Form.Label>ARN/AFMI No</Form.Label>
              <Form.Control
                value={form.arn_afmi_no}
                onChange={(e) =>
                  setForm({ ...form, arn_afmi_no: e.target.value })
                }
              />
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditPartnerModal;
